import { ExtractedContextualValue } from './ContextualValue';

/**
 * Il campo contestuale è valido solamente se non è null, non è una stringa
 * vuota e non è un trattino (alcuni IdP)
 */
export function isContextualValueEmpty(value: ExtractedContextualValue) {
  return (
    value == null ||
    (typeof value === 'string' && value.trim() === '') ||
    value === '-'
  );
}
